<template>
  <div>
    <el-dialog title="修改订单状态" :visible.sync="updateOrderStatusDialog" width="30%">
      <el-form label-width="100px">
        <el-form-item label="是否支付" v-if="orderType !== 'RACE' && orderType !== 'RACE_RAISE'">
          <el-select v-model="editForm.enumPay" placeholder="请选择是否支付" style="width: 100%;">
            <el-option
              v-for="item in payStatus"
              :key="item.id"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="订单状态">
          <el-select v-model="editForm.enumStatus" placeholder="请选择订单状态" style="width: 100%;">
            <el-option
              v-for="item in saleStatus"
              :key="item.id"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateOrderStatusDialog = false">取 消</el-button>
        <el-button type="primary" @click="updateStatus">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { courtSaleStatus,goodsSaleStatus,payYesNo,raceSaleStatus, raceRaiseStatus } from '@/js/enum'
import { gameOrderStatus, updateOrderStatus } from '@/api/order/order'
import { editRacesById } from '@/api/race/raceRaise'
import { getData } from '@/utils/code'

export default {
  name: 'modifyOrder',
  data() {
    return {
      saleStatus: [],
      editForm: {},
      payStatus: payYesNo,
      updateOrderStatusDialog: false,
      orderType: ''
    }
  },
  created() {

  },
  methods: {
    editDialog(row, val) {
      this.orderType = val
      this.editForm = JSON.parse(JSON.stringify(row))
      if (val === 'COURT' || val === 'TRAVEL') {
        this.saleStatus = courtSaleStatus
      }
      if (val === 'GOODS') {
        this.saleStatus = goodsSaleStatus
      }
      if (val === 'RACE') {
        this.saleStatus = raceSaleStatus
      }
      if (val === 'RACE_RAISE') {
        this.saleStatus = raceRaiseStatus
      }
      this.updateOrderStatusDialog = true
    },

    //修改
    updateStatus() {
      const orderStatus = {
        defineTime: this.editForm.defineTime,
        enumPay: this.editForm.enumPay,
        enumPayment: this.editForm.enumPayment,
        enumStatus: this.editForm.enumStatus
      }

      const gameStatus = {
        enumStatus: this.editForm.enumStatus
      }

      if (this.orderType === 'RACE') {
        gameOrderStatus(this.editForm.id, gameStatus).then(res => {
          let data = getData(res)
          if (data != null) {
            this.$emit('refresh-list')
            this.updateOrderStatusDialog = false
          }
        })
      }else if (this.orderType === 'RACE_RAISE') {
        editRacesById(this.editForm.id, gameStatus).then(res => {
          let data = getData(res)
          if (data != null) {
            this.$emit('refresh-list')
            this.updateOrderStatusDialog = false
          }
        })
      } else {
        updateOrderStatus(this.editForm.orderId, orderStatus).then((res) => {
          let data = getData(res)
          if (data != null) {
            this.$emit('refresh-list')
            this.updateOrderStatusDialog = false
          }
        })
      }




    },
  }
}
</script>

<style scoped>

</style>
